export default {"src":"/_next/static/media/backIcon2.01c93d94.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};